module.exports = __webpack_public_path__ + "img/SqualoSport-interno5.2001c7b5.jpeg";